import "current-script-polyfill";
// Transpiler for older browsers

import "core-js/stable";
// optional but required for transforming generator fns.
import "regenerator-runtime/runtime";

import "@babel/polyfill";
import Vue from "vue";
import App from "./App.vue";
import axios from "axios";
import store from "./store";
import router from "./router";

import VueAnalytics from "vue-analytics";
//and then use it in main.js
Vue.use(VueAnalytics, {
  id: "G-MFGYWTG6N9",
  router,
  autoTracking: {
    screenview: true,
  },
});

import i18n from "./i18n";
import VueSlider from "vue-slider-component";
import VueCompositionAPI from "@vue/composition-api";
import VueCarousel from "vue-carousel";
Vue.use(VueCarousel);
import VTooltip from "v-tooltip";
import vSelect from "vue-select";

Vue.use(Notifications);

import Notifications from "vue-notification";

Vue.use(VTooltip);

import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faInfoCircle,
  faAngleRight,
  faAngleLeft,
  faTimes,
  faMobile,
  faEnvelope,
  faSearch,
  faCheckCircle,
  faEdit,
  faTrophy,
  faStar
} from "@fortawesome/free-solid-svg-icons";
import { faFacebook, faInstagram, faLinkedin, faWhatsapp } from "@fortawesome/free-brands-svg-icons";

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { dom } from "@fortawesome/fontawesome-svg-core";

dom.watch();
library.add(faInfoCircle);
library.add(faAngleRight);
library.add(faAngleLeft);
library.add(faTimes);
library.add(faInstagram);
library.add(faLinkedin);
library.add(faFacebook);
library.add(faWhatsapp);
library.add(faMobile);
library.add(faEnvelope);
library.add(faSearch);
library.add(faCheckCircle);
library.add(faEdit);
library.add(faTrophy);
library.add(faStar);

Vue.component("font-awesome-icon", FontAwesomeIcon);

import cssVars from "css-vars-ponyfill";

VTooltip.options.defaultTemplate =
  '<div class="tooltip-vue" role="tooltip"><div class="tooltip-vue-arrow"></div><div class="tooltip-vue-inner"></div></div>';
VTooltip.options.defaultArrowSelector =
  ".tooltip-vue-arrow, .tooltip-vue__arrow";
VTooltip.options.defaultInnerSelector =
  ".tooltip-vue-inner, .tooltip-vue__inner";
VTooltip.options.popover.defaultBaseClass = "vue-tooltip";
VTooltip.options.popover.defaultInnerClass = "tooltip-vue-inner";

Vue.component("VueSlider", VueSlider);

import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
Vue.use(BootstrapVue);

Vue.use(VueCompositionAPI);

Vue.component("v-select", vSelect);

import "vue-easytable/libs/theme-default/index.css"; // import style
import VueEasytable from "vue-easytable"; // import library

Vue.use(VueEasytable);


import Vue2Filters from 'vue2-filters'
var Vue2FiltersConfig = {
  currency: {
    symbol: '€',
    decimalDigits: 2,
    thousandsSeparator: '.',
    decimalSeparator: ',',
    symbolOnLeft: false
  },
  number: {
    thousandsSeparator: '.',
    decimalSeparator: ',',
  },
}

Vue.use(Vue2Filters, Vue2FiltersConfig)

import "vue-select/dist/vue-select.css";
import Commons from "./plugins/commons";

Vue.config.productionTip = false;

axios.defaults.baseUrl = process.env.VUE_BASE_URL;

const credential = store.getters['config/getCredential']

axios.interceptors.request.use(function(config) {
  if(credential.brand) {
      config.headers["X-ApiBrand"] = credential.brand;
  }
  return config;
}, function(err) {
  return Promise.reject(err);
});

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response;
    let msg =
      status?.status === 426
        ? "Il tuo profilo non è ancora stato abilitato o è stato disabilitato. Attendi o contatta support@gioielleriaitaliana.com"
        : status.data.errorMessage;
    Vue.notify({
      group: "foo",
      type: "error",
      title: msg,
      duration: 5000,
    });
  }
);

Vue.prototype.$http = axios;

Vue.use(Commons);

// Default values
cssVars({
  // Targets
  rootElement: document,
  shadowDOM: false,
  // Sources
  include: "link[rel=stylesheet],style",
  exclude: "",
  variables: {},
  // Options
  onlyLegacy: true,
  preserveStatic: true,
  preserveVars: false,
  silent: false,
  updateDOM: true,
  updateURLs: true,
  watch: false,

  // Callbacks
  onBeforeSend: function (xhr, elm, url) {
    // ...
  },
  onError: function (message, elm, xhr, url) {
    // ...
  },
  onWarning: function (message) {
    // ...
  },
  onSuccess: function (cssText, elm, url) {
    // ...
  },
  onComplete: function (cssText, styleElms, cssVariables, benchmark) {
    // ...
  },
  onFinally: function (hasChanged, hasNativeSupport, benchmark) {
    // ...
  },
});

new Vue({
  store,
  router,
  axios,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
